"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12 3 2 12h3v8h6v-6h2v6h6v-8h3zm5 15h-2v-6H9v6H7v-7.81l5-4.5 5 4.5z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M7 10.19V18h2v-6h6v6h2v-7.81l-5-4.5z",
  opacity: ".3"
}, "1")], 'HomeTwoTone');